import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

// material-ui
import { useTheme } from '@mui/material/styles';
import { useMediaQuery, Box, Container, Toolbar } from '@mui/material';

// project import
import Drawer from './Drawer';
import Header from './Header';
import HorizontalBar from './Drawer/HorizontalBar';
// import Breadcrumbs from 'components/@extended/Breadcrumbs';

import { MenuOrientation } from 'config';
// import navigation from 'menu-items';
import useConfig from 'hooks/useConfig';
import { dispatch } from 'store';
import { openDrawer } from 'store/reducers/menu';
import FirstLoad from 'components/FirstLoad';

//  socket
import WebSocketProvider from 'socket.io';
import useNotifications from 'hooks/Notifications/useNotification';
// ==============================|| MAIN LAYOUT ||============================== //

const MainLayout = () => {
  const theme = useTheme();
  const matchDownXL = useMediaQuery(theme.breakpoints.down('xl'));
  const downLG = useMediaQuery(theme.breakpoints.down('lg'));
  const { getUnreadNotificationsDataAction } = useNotifications();
  const { container, miniDrawer, menuOrientation } = useConfig();

  const isHorizontal = menuOrientation === MenuOrientation.HORIZONTAL && !downLG;

  // set media wise responsive drawer
  useEffect(() => {
    if (!miniDrawer) {
      dispatch(openDrawer(!matchDownXL));
    }
    const abortController = new AbortController();

    getUnreadNotificationsDataAction({ signal: abortController.signal });
    return () => {
      abortController.abort();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [matchDownXL]);

  return (
    <WebSocketProvider>
      <Box sx={{ display: 'flex', width: '100%' }}>
        <Header />
        {!isHorizontal ? <Drawer /> : <HorizontalBar />}
        <Box component="main" sx={{ width: 'calc(100% - 260px)', height: '100%', flexGrow: 1, px: { xs: 2, sm: 3 }, pt: { xs: 2, sm: 3 } }}>
          <Toolbar sx={{ minHeight: 48, mt: isHorizontal ? 2 : 'inherit' }} />
          <Container
            maxWidth={container ? 'xl' : false}
            sx={{
              ...(container && { px: { xs: 0, sm: 2 } }),
              paddingRight: '0 !important',
              paddingLeft: '0 !important',
              position: 'relative',
              minHeight: 'calc(100vh - 100px)',
              display: 'flex',
              flexDirection: 'column'
            }}
          >
            <Outlet />
            <FirstLoad />
          </Container>
        </Box>
      </Box>
    </WebSocketProvider>
  );
};

export default MainLayout;
